import * as React from 'react';
import PerguntasService from '../../../services/PerguntasService';

export const ReorderFuncionalidadesModel = ({ setAllValuesOptions }) => {
  const [tipo, setTipo] = React.useState('');
  const [dataType, setDataType] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const getData = async () => {
      let response = undefined;
      setIsLoading(true);
      if (tipo !== '') {
        response = await PerguntasService.getDataByType(tipo);
        setDataType(response?.data.faqs ?? []);
      } else {
        response = await PerguntasService.getAssuntos();
        setDataType(response?.data ?? []);
      }

      setIsLoading(false);
    };

    getData();
  }, [tipo]);

  const updateOrder = (result) => {
    if (!result.destination) return;

    const items = Array.from(dataType);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setDataType(items);
  };

  const saveOrder = async () => {
    let valuesOrdered,
      response = undefined;
    if (tipo === '') {
      valuesOrdered = dataType.map(({ id, ordenar, nome, tipo: lolalType }) => {
        return {
          id,
          ordenar,
          nome,
          tipo: lolalType,
        };
      });
    } else {
      valuesOrdered = dataType.map(
        ({ id, ordenar, pergunta, resposta, tipo: lolalType }) => {
          return {
            id,
            ordenar,
            pergunta,
            resposta,
            tipo: lolalType,
          };
        }
      );
    }

    if (tipo !== '') {
      response = await PerguntasService.orderFaq({ faqs: valuesOrdered });
    } else {
      response = await PerguntasService.orderAssuntos({
        assuntos: valuesOrdered,
      });
    }

    let options = await PerguntasService.getOptions();
    setAllValuesOptions(options.data);

    return response;
  };

  return {
    tipo,
    setTipo,
    dataType,
    updateOrder,
    saveOrder,
    isLoading,
  };
};
